import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import { createBrowserHistory } from 'history';
import LoadingScreen from '../../app/layout/LoadingScreen';

const locationHelper = locationHelperBuilder({});
const history = createBrowserHistory();

export const UserIsNotAuthenticated = connectedRouterRedirect({
  wrapperDisplayName: 'UserIsNotAuthenticated',
  AuthenticatingComponent: LoadingScreen,
  allowRedirectBack: false,
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/signup/payment',
  authenticatingSelector: ({ firebase: { auth, isInitializing, profile } }) =>
    !auth.isLoaded || !profile.isLoaded || isInitializing === true,
  authenticatedSelector: ({ firebase: { auth, profile } }) =>
    auth.isLoaded && auth.isEmpty && profile.isLoaded && profile.isEmpty,
  redirectAction: newLoc => dispatch => {
    history.replace(newLoc);
    // routerActions.replace or other redirect
    dispatch({ type: 'UNAUTHED_REDIRECT' });
  }
});

export const UserIsSubscribed = connectedRouterRedirect({
  wrapperDisplayName: 'UserIsSubscribed',
  AuthenticatingComponent: LoadingScreen,
  allowRedirectBack: false,
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/signup/payment',
  authenticatingSelector: ({ firebase: { auth, isInitializing, profile } }) =>
    !auth.isLoaded || !profile.isLoaded || isInitializing === true,
  authenticatedSelector: ({ firebase: { auth, profile } }) =>
    auth.isLoaded &&
    !auth.isEmpty &&
    profile.isLoaded &&
    profile.subscriptionActive === true,
  redirectAction: newLoc => dispatch => {
    history.replace(newLoc);
    // routerActions.replace or other redirect
    dispatch({ type: 'UNAUTHED_REDIRECT' });
  }
});

export const UserNeedsToPay = connectedRouterRedirect({
  wrapperDisplayName: 'UserNeedsToPay',
  AuthenticatingComponent: LoadingScreen,
  allowRedirectBack: false,
  redirectPath: ({ firebase: { auth, profile } }, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) ||
    (profile.isLoaded && profile.subscriptionActive === true
      ? '/dashboard'
      : '/'),
  authenticatingSelector: ({ firebase: { auth, isInitializing, profile } }) =>
    !auth.isLoaded || !profile.isLoaded || isInitializing === true,
  authenticatedSelector: ({ firebase: { auth, profile } }) =>
    auth.isLoaded &&
    !auth.isEmpty &&
    profile.isLoaded &&
    !profile.subscriptionActive,
  redirectAction: newLoc => dispatch => {
    history.push(newLoc);
    // routerActions.replace or other redirect
    dispatch({ type: 'UNAUTHED_REDIRECT' });
  }
});

//  AFFILIATE/KINSEY ROUTER

export const AffiliateUserIsNotAuthenticated = connectedRouterRedirect({
  wrapperDisplayName: 'UserIsNotAuthenticated',
  AuthenticatingComponent: LoadingScreen,
  allowRedirectBack: false,
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/kinsey/signup/payment',
  authenticatingSelector: ({ firebase: { auth, isInitializing, profile } }) =>
    !auth.isLoaded || !profile.isLoaded || isInitializing === true,
  authenticatedSelector: ({ firebase: { auth, profile } }) =>
    auth.isLoaded && auth.isEmpty && profile.isLoaded && profile.isEmpty,
  redirectAction: newLoc => dispatch => {
    history.push(newLoc);
    // routerActions.replace or other redirect
    dispatch({ type: 'UNAUTHED_REDIRECT' });
  }
});

export const AffiliateUserNeedsToPay = connectedRouterRedirect({
  wrapperDisplayName: 'UserNeedsToPay',
  AuthenticatingComponent: LoadingScreen,
  allowRedirectBack: false,
  redirectPath: ({ firebase: { auth, profile } }, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) ||
    (profile.isLoaded && profile.subscriptionActive === true
      ? '/dashboard'
      : '/kinsey'),
  authenticatingSelector: ({ firebase: { auth, isInitializing, profile } }) =>
    !auth.isLoaded || !profile.isLoaded || isInitializing === true,
  authenticatedSelector: ({ firebase: { auth, profile } }) =>
    auth.isLoaded &&
    !auth.isEmpty &&
    profile.isLoaded &&
    !profile.subscriptionActive,
  redirectAction: newLoc => dispatch => {
    history.push(newLoc);
    // routerActions.replace or other redirect
    dispatch({ type: 'UNAUTHED_REDIRECT' });
  }
});
